import React from 'react';
import { TFunction } from 'i18next';
import { WidgetsKindEnum } from 'graphql-common';
import { FieldItem, Values } from '@lib/interfaces/form';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import { isWidgetSelected } from './validationHelpers';

/**
 * Returns fields for Sectors Performance Metrics (Deadline Tracker) widget
 */
export default function getSectorsDeadlineTrackerFields(
  t: TFunction,
): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.SectorsDeadlineTrackerInfo,
      customRender: () => (
        <SupportiveMessage
          text={t('home.widget-sectors-deadline-tracker-info')}
          leftIcon="info"
          color={SupportiveMessageColor.Gray}
          iconColor={SupportiveMessageIconColor.Inner}
          type={SupportiveMessageType.Transparent}
          hasBottomSpace={false}
        />
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(
          values,
          WidgetsKindEnum.SectorsPerformanceMetricsByDeadlinesMissed,
        ),
    },
  ];
}
